module.exports = __webpack_public_path__ + "static/img/off-3p.1c862c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newHome/village/off-3p.png
// module id = zdo1
// module chunks = 1